import sk from './sk.json'
const trans = sk
export default trans
